module.exports = __webpack_public_path__ + "static/media/YB5M13_3.e86201ef.jpg";